if (!customElements.get('cdda-popup')) {
  class CddaPopup extends HTMLElement {
    static OPEN_CLASS = 'is-open';

    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    updateNumbericDateInput() {
      const dateInput = this.querySelector('[data-cf-column-key="date"]');
      if (!dateInput) return;

      const now = new Date();
      const dateInputValue = now.toLocaleDateString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
      });

      dateInput.value = dateInputValue;
    }

    updatePlaceholderDate() {
      const options = {
        timeZone: 'America/New_York',
        year: '2-digit',
        month: 'long',
        day: '2-digit',
      };

      const dateString = new Intl.DateTimeFormat('en-US', options).format(
        new Date(),
      );
      const currentDate = new Date(dateString);

      this.month = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        timeZone: 'America/New_York',
      }).format(currentDate);

      this.day = String(currentDate.getDate()).padStart(2, '0');
      this.year = String(currentDate.getFullYear()).slice(-2);

      const dateParagraph = this.querySelector('.cdda__date-paragraph div div');
      if (!dateParagraph) return;

      dateParagraph.innerHTML = dateParagraph.innerHTML
        .replace(
          '[DATE]',
          `<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${this.month} ${this.day}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>`,
        )
        .replace('[YEAR]', `<span>&nbsp;&nbsp;${this.year}&nbsp;&nbsp;</span>`);
    }

    setUDCEmpty() {
      const udc = this.querySelector('[name="udc_signature"]');
      if (!udc) return;
      udc.value = '';
    }

    setDistributor() {
      const dist = this.querySelector('[name=upper_deck_authorized_dist]');
      if (!dist) return;
      if (dist.value != 'XYAB') dist.value = 'XYAB';
    }

    updateCheckboxes() {
      this.querySelectorAll('[type="checkbox"]').forEach((input) => {
        input.required = true;
        input.oninvalid = () => {};
      });
    }

    handleToggle() {
      this.updateNumbericDateInput();
      this.updatePlaceholderDate();
      this.setUDCEmpty();
      this.setDistributor();
      this.updateCheckboxes();

      this.classList.toggle(CddaPopup.OPEN_CLASS);

      this.classList.contains(CddaPopup.OPEN_CLASS)
        ? bodyScroll.lock(this.querySelector('[js-inner]'))
        : bodyScroll.clear();

      this.initCancel();
    }

    generateSignatureImage(text) {
      const canvas = document.getElementById('signatureCanvas');
      const ctx = canvas.getContext('2d');

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = '20px Pacifico';
      ctx.fillStyle = 'black';
      ctx.textBaseline = 'top';

      ctx.fillText(text, 5, 0);

      return canvas.toDataURL('image/png');
    }

    disconnectedCallback() {
      document.removeEventListener('cdda-popup:toggle', this.handleToggleRef);
    }

    checkAriaRequiredInputs(form) {
      const requiredInputs = form.querySelectorAll('[aria-required="true"]');

      for (const input of requiredInputs) {
        if (!input.value || input.value.trim() === '') {
          return false;
        }
      }

      return true;
    }

    initCancel() {
      if (this.isCancelInitialized) return;

      this.cancelButton = this.querySelector('.cf-cancel');
      if (!this.cancelButton) return;

      this.isCancelInitialized = true;

      this.cancelButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        this.handleToggle();
      });
    }

    connectedCallback() {
      document.addEventListener('cdda-popup:toggle', this.handleToggleRef);

      this.form = this.querySelector('form');

      if (!this.form) return;

      this.form
        .addEventListener('submit', (event) => {
          if (!this.checkAriaRequiredInputs(this.form)) {
            return;
          }

          const formData = new FormData(event.target);

          formData.set('customer_name', this.getAttribute('js-customer-name'));
          formData.set(
            'customer_email',
            this.getAttribute('js-customer-email'),
          );

          formData.set(
            'signature_image',
            this.generateSignatureImage(formData.get('shop_owner_signature')),
          );

          const shopInitials = formData.get('shop_initials');
          formData.set('shop_initials_2', shopInitials);
          formData.set('shop_initials_3', shopInitials);

          formData.set('p_date', `${this.month} ${this.day}`);
          formData.set('p_year', this.year);

          formData.delete('udc_signature');

          fetch('/apps/pdf-fill', {
            method: 'POST',
            body: formData,
          })
            .then((response) => response.text())
            .then((data) => console.log(data))
            .catch((error) => console.error('Error:', error));
        })
        .finally(() => {});
    }
  }

  customElements.define('cdda-popup', CddaPopup);
}
